import { useDispatch, useSelector } from "react-redux";
import { serviceActions } from "../../store/service-Slice";
import { getEventsForGateway, getGroups, getSingleGateway, getSinglePadlock, getSinglePadlockEvents, updateGateway, updateLockDetails } from "../../Api Methods/Api";
import { Await, defer, useLoaderData, useNavigate } from "react-router-dom";
import Stats2 from "../../components/UI/Stats/Stats2";
import classes from '../Padlocks/padlockEntity.module.css'
import { format } from "date-fns";
import { Suspense, useEffect, useRef, useState } from "react";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import LogsTableLayout from "../../components/Table/LogsTableLayout";
import PadlockEvents from "../Padlocks/PadlockEvents";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import DataManager from "../../hooks/DataManager";
import GatewayEvents from "./gatewayEvents";
import Lottie from 'lottie-react';
import successAnim from '../../assets/animations/success.json';


const GatewayEntity = () => {

    const { gateway } = useLoaderData();

    console.log(gateway);

    const [localGateway, setLocalGateway] = useState(gateway)
    const companyName = useSelector(state => state.auth.companyName);
    const isAllowed = companyName == "EyeSpyFX" ? true : false
    const isCustomerBillingAllowed = companyName === "EyeSpyFX" || companyName === "RE:SURE"
    const [unauthotisedClick, setUnauthorisedClick] = useState(false)

    const [gatewayEvents, setGatewayEvents] = useState([])
    const [showLoading, setShowLoading] = useState(true)
    const dispatch = useDispatch();
    const [groups, setGroups] = useState([])
    const token = localStorage?.getItem('token');
    const client = localStorage?.getItem('client');
    const apiData = {
        token, 
        client
    }
    
    const [changeGatewayName, setChangeGatewayName] = useState(false)
    const [changeOwnedBy, setChangeOwnedBy] = useState(false)
    const [changeBillable, setChangeBillable] = useState(false)
    const [changeBilledTo, setChangeBilledTo] = useState(false)
    const [gatewayName, setNewGatewayName] = useState(localGateway.name)
    const [changeBillingFrequency, setChangeBillingFrequency] = useState(false)
    const [changeDateOfFirstInvoice, setChangeDateOfFirstInvoice] = useState(false)
    const [changeDateOfLastInvoice, setChangeDateOfLastInvoice] = useState(false)
    const [changePoweredBy, setChangePoweredBy] = useState(false)

    const [newOwnerGroupName, setNewOwnerGroupName] = useState(localGateway.ownedByGroupName || localGateway.owner)
    const [newBilledToGroupName, setNewBilledToGroupName] = useState(localGateway.billedToGroupName || localGateway.owner)
    const [changeCustomerBilledTo, setChangeCustomerBilledTo] = useState(false)
    const [newCustomerBilledToGroupName, setNewCustomerBilledToGroupName] = useState(localGateway.customerBilledToGroupName || "")
    const [showUpdateBilledToPrompt, setShowUpdateBilledToPrompt] = useState(false)
    const [pendingOwnerID, setPendingOwnerID] = useState(null)

    const [navigateToLinkedSite, setNavigateToLinkedSite] = useState(false)
    const [navigateToGroup, setNavigateToGroup] = useState(false)
    const [newBillingFrequency, setNewBillingFrequency] = useState("")
    const [newDateOfFirstInvoice, setNewDateOfFirstInvoice] = useState("")
    const [newDateOfLastInvoice, setNewDateOfLastInvoice] = useState("")
    const [newPoweredOption, setNewPoweredOption] = useState("")

    const [userObject, setUserObject] = useState([])

    const toast = useRef(null);
    const navigate = useNavigate();

    const billingOptions = [
        "Monthly",
        "Annually"
    ]

    const convertGroupIDToName = (groupID) => {
        let group = groups.find(group => group.id == groupID)
        let groupName = ""
        if (group){
            groupName = group.name
        }
        return groupName
    }
    
    const ownedBy = localGateway.ownedByGroupName !== null ? localGateway.ownedByGroupName || localGateway.usedBy : "Unlinked"
    
    const GetGroups = async () => {
        const groups = await getGroups(apiData, dispatch)
        setGroups(groups)
    }

    const GetGatewayEvents = async () => {
        const gatewayIMEI = gateway.IMEI.substring(11, 15)
        const response = await getEventsForGateway(apiData, `x${gatewayIMEI}`)
        if (response.success){
            setGatewayEvents(response.data)
            setShowLoading(false)
        }
    }

    useEffect(() => {
        GetGatewayEvents();
        GetGroups();
    }, [])

    

    useEffect(() => {
        if (navigateToLinkedSite){
            navigate(`/Dashboard/SiteView/${gateway.deviceUUID}`)
        }
    }, [navigateToLinkedSite])

    useEffect(() => {
        if (navigateToGroup){
            const groupClicked = groups.find(g => g.name === localGateway.usedBy);
            sessionStorage.setItem('groupClicked', groupClicked.name)   
            sessionStorage.setItem('groupPath', groupClicked.group_path)
            sessionStorage.setItem('groupClickedID', groupClicked.id)   
            navigate(`/Dashboard/Groups/GroupSites/`)
        }
    }, [navigateToGroup])

    const UpdateGatewayDetails = async (columnName, newValue) => {
        let body = {
            gatewayIMEI: gateway.IMEI,
            columnName: columnName,
            newValue: newValue
        }
        console.log(body);

        const response = await updateGateway(apiData, body, dispatch)
        console.log(response);
        if (response.success){
            setLocalGateway((prevGatewayObj) => ({
                ...prevGatewayObj,
                [columnName]: body.newValue,
            }));
        }
    }

    useEffect(() => {
        if (unauthotisedClick){
            toast.current.show({ severity: 'error', summary: 'Unauthorsied', detail: 'Please contact your administrator to update billing for this Gateway', life: 3000 });
            setUnauthorisedClick(false)
        }
    }, [unauthotisedClick])

    const accept = async () => {
        UpdateGatewayDetails("billable", localGateway.billable == 1 ? 0 : 1)    
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Billing status updated', life: 3000 });
    }

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Cancelled', detail: 'Changes discarded', life: 3000 });
    }

    const defaultConfirmProps = {
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        defaultFocus: 'accept',
        accept,
        reject,
    };

    const updateGatewayName = async () => {
        UpdateGatewayDetails("name", gatewayName)

        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Gateway name updated', life: 3000 });
        setChangeGatewayName(false)
    }   

    const updateOwnedBy = async () => {
        const newOwnerID = groups.find(g => g.name === newOwnerGroupName).id;
        UpdateGatewayDetails("ownedByGID", newOwnerID)
        setChangeOwnedBy(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            ownedByGroupName: newOwnerGroupName,
        }));

        setPendingOwnerID(newOwnerID)
        setShowUpdateBilledToPrompt(true)
    }

    const updateBilledTo = async () => {
        const newBilledToID = groups.find(g => g.name === newBilledToGroupName).id;
        UpdateGatewayDetails("billedToGID", newBilledToID)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Gateway subscription updated', life: 3000 });
        setChangeBilledTo(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            billedToGroupName: newBilledToGroupName,
        }));
    }

    const updateCustomerBilledTo = async () => {
        const newCustomerBilledToID = groups.find(g => g.name === newCustomerBilledToGroupName)?.id;
        if (!newCustomerBilledToID) return;
        UpdateGatewayDetails("customerBilledToGID", newCustomerBilledToID)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Customer billed to updated', life: 3000 });
        setChangeCustomerBilledTo(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            customerBilledToGroupName: newCustomerBilledToGroupName,
            customerBilledToGID: newCustomerBilledToID,
        }));
    }

    const updateBillingFrequency = async () => {
        UpdateGatewayDetails("billingFrequency", newBillingFrequency.toLowerCase())
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Billing frequency updated', life: 3000 });
        setChangeBillingFrequency(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            billingFrequency: newBillingFrequency,
        }));
    }

    const updateDateOfFirstInvoice = async () => {
        const formattedDate = newDateOfFirstInvoice ? format(newDateOfFirstInvoice, "yyyy-MM-dd") : ""
        UpdateGatewayDetails("firstInvoiceDate", formattedDate)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Invoice date updated', life: 3000 });
        setChangeDateOfFirstInvoice(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            firstInvoiceDate: formattedDate,
        }));
    }

    const updateDateOfLastInvoice = async () => {
        const formattedDate = newDateOfLastInvoice ? format(newDateOfLastInvoice, "yyyy-MM-dd") : ""
        UpdateGatewayDetails("lastInvoiceDate", formattedDate)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Invoice date updated', life: 3000 });
        setChangeDateOfLastInvoice(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            lastInvoiceDate: formattedDate,
        }));
    }

    const updatePoweredBy = async () => {
        UpdateGatewayDetails("poweredBy", newPoweredOption)
        toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Gateway power source updated', life: 3000 });
        setChangePoweredBy(false)

        setLocalGateway((prevGatewayObj) => ({
            ...prevGatewayObj,
            poweredBy: newPoweredOption,
        }));
    }

    const convertPowerOption = (poweredBy) => {
        switch (poweredBy) {
            case "solar" :
                return "Solar panel"
            break;
            case "mains" : 
                return "Mains powered"
            break;
            case "battery":
                return "Battery only"
            break;
        }
    }

    const convertStatus = (status) => {
        let newStatus = status
        switch (status) {
            case "stale" : 
                newStatus = "Missed 2 polls" 
            break;
            case "potentiallyStale" : 
                newStatus = "Missed 1 poll" 
            break;
        }

        return newStatus;
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                header="Set Gateway name"
                visible={changeGatewayName}
                style={{ width: '50vw' }}
                onHide={() => { if (!changeGatewayName) return; setChangeGatewayName(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <InputText
                        value={gatewayName}
                        onChange={(e) => setNewGatewayName(e.target.value)}
                        style={{ width: '100%', fontSize: '1rem' }}
                    />

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeGatewayName(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateGatewayName}/>
                    </div>
                </div>
            </Dialog>

            <ConfirmDialog
                    visible={changeBillable}
                    onHide={() => setChangeBillable(false)}
                    {...defaultConfirmProps}
                    message={`Are you sure you want to ${localGateway.billable == 0 ? 'start' : 'stop'} billing for this Gateway?`}
            />

            <Dialog
                header="Select new owner"
                visible={changeOwnedBy}
                style={{ width: '50vw', height:'20vw' }}
                onHide={() => { if (!changeOwnedBy) return; setChangeOwnedBy(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex:1201}}>
                    <Dropdown 
                        placeholder={newOwnerGroupName} 
                        options={groups.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewOwnerGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeOwnedBy(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateOwnedBy}/>
                    </div>
                </div>

            </Dialog>

            <Dialog
                header="Owner updated"
                visible={showUpdateBilledToPrompt}
                style={{ width: '35vw' }}
                onHide={() => setShowUpdateBilledToPrompt(false)}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 150, height: 150 }}
                    />
                    <p style={{ color: '#6e6e6eff', textAlign: 'center' }}>Owner updated successfully. Would you also like to update Billed To?</p>
                    <br />
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <Button label="No" icon="pi pi-times" severity="secondary" onClick={() => setShowUpdateBilledToPrompt(false)} />
                        <Button label="Yes" icon="pi pi-check" severity="success" onClick={() => {
                            setNewBilledToGroupName(newOwnerGroupName)
                            UpdateGatewayDetails("billedToGID", pendingOwnerID)
                            setLocalGateway((prevGatewayObj) => ({
                                ...prevGatewayObj,
                                billedToGroupName: newOwnerGroupName,
                            }))
                            toast.current.show({ severity: 'success', summary: 'Confirmed', detail: 'Billed To updated', life: 3000 })
                            setShowUpdateBilledToPrompt(false)
                        }} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Select new purchasee"
                visible={changeBilledTo}
                style={{ width: '50vw', height:'35vw' }}
                onHide={() => { if (!changeBilledTo) return; setChangeBilledTo(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex:1201}}>
                    <Dropdown 
                        placeholder={newBilledToGroupName} 
                        options={groups.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewBilledToGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeBilledTo(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateBilledTo}/>
                    </div>
                </div>

            </Dialog>

            <Dialog
                header="Select customer billed to"
                visible={changeCustomerBilledTo}
                style={{ width: '50vw', height: '35vw' }}
                onHide={() => { if (!changeCustomerBilledTo) return; setChangeCustomerBilledTo(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex: 1201 }}>
                    <Dropdown
                        placeholder={newCustomerBilledToGroupName || "Select group"}
                        options={groups.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewCustomerBilledToGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeCustomerBilledTo(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateCustomerBilledTo} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Select new billing frequency"
                visible={changeBillingFrequency}
                style={{ width: '30vw', height:'20vw' }}
                onHide={() => { if (!changeBillingFrequency) return; setChangeBillingFrequency(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex:1201}}>
                    <Dropdown
                        placeholder={newBillingFrequency}
                        options={billingOptions}
                        onChange={(e) => setNewBillingFrequency(e.value)}/>
                </div>
                <br/>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeBillingFrequency(false)} className="p-button-secondary"/>
                    <Button  icon="pi pi-save" label="Save" onClick={updateBillingFrequency}/>
                </div>
            </Dialog>

            <Dialog
                header="Set date of hardware invoice"
                visible={changeDateOfFirstInvoice}
                style={{ width: '30vw' }}
                onHide={() => { if (!changeDateOfFirstInvoice) return; setChangeDateOfFirstInvoice(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Calendar
                        value={newDateOfFirstInvoice}
                        onChange={(e) => setNewDateOfFirstInvoice(e.value)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfFirstInvoice(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateDateOfFirstInvoice} disabled={!newDateOfFirstInvoice}/>
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Set date of 1st SaaS invoice"
                visible={changeDateOfLastInvoice}
                style={{ width: '30vw' }}
                onHide={() => { if (!changeDateOfLastInvoice) return; setChangeDateOfLastInvoice(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Calendar
                        value={newDateOfLastInvoice}
                        onChange={(e) => setNewDateOfLastInvoice(e.value)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button  icon="pi pi-times" label="Cancel" onClick={() => setChangeDateOfLastInvoice(false)} className="p-button-secondary"/>
                        <Button  icon="pi pi-save" label="Save" onClick={updateDateOfLastInvoice} disabled={!newDateOfLastInvoice}/>
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Set power source"
                visible={changePoweredBy}
                style={{ width: '30vw' }}
                onHide={() => setChangePoweredBy(false)}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Button label="Mains powered" icon="pi pi-bolt" onClick={() => setNewPoweredOption("mains")} className={newPoweredOption === "mains" ? "" : "p-button-outlined"} />
                    <Button label="Solar panel" icon="pi pi-sun" onClick={() => setNewPoweredOption("solar")} className={newPoweredOption === "solar" ? "" : "p-button-outlined"} />
                    <Button label="Battery only" icon="pi pi-exclamation-circle" onClick={() => setNewPoweredOption("battery")} className={newPoweredOption === "battery" ? "" : "p-button-outlined"} />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangePoweredBy(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updatePoweredBy} disabled={!newPoweredOption} />
                    </div>
                </div>
            </Dialog>

            <div className={classes['activtyPage_container']}>
                <Await resolve={localGateway}>
                    {(loadedGateway) => (
                        <>
                        <div className={classes.container}>
                            <Stats2 title={"Gateway ID"} value={loadedGateway.IMEI} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Gateway name"} value={loadedGateway.name || "No name set"} isLoadingStats={false} isStatic={true} setChangeGatewayName={setChangeGatewayName} editable={true} />

                            {loadedGateway.usedBy && <Stats2 title={"Linked to"} value={loadedGateway.tag || loadedGateway.linkedSite} isLoadingStats={false} isStatic={true} setNavigateToLinkedSite={setNavigateToLinkedSite} /> }
                            {loadedGateway.dateLinked && <Stats2 title={"Date linked"} value={format(new Date(loadedGateway.dateLinked), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} /> }


                            <Stats2 title={"Registration date"} value={format(new Date(loadedGateway.dateAdded), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                            {/* <Stats2 title={"Registered by"} value={loadedPadlock.registeredByName} isLoadingStats={false} isStatic={true} /> */}

                            <Stats2 title={"Last updated"} value={format(new Date(loadedGateway.lastSeenAt), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Battery"} value={loadedGateway.battery !== 0 ? `${loadedGateway.battery}%` : "Unknown"} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Powered by"} value={loadedGateway.poweredBy != "" ? `${convertPowerOption(loadedGateway.poweredBy)}` : "Unknown"} isLoadingStats={false} isStatic={true} setChangePoweredBy={setChangePoweredBy} editable={true} />
                            <Stats2 title={"Signal"} value={loadedGateway.signal !== 0 ? `${loadedGateway.signal > 100 ? 100 : loadedGateway.signal}%` : "Unknown"} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Network type"} value={(loadedGateway.serviceType !== 7 && loadedGateway.serviceType)? `${loadedGateway.serviceType}` : "Unknown"} isLoadingStats={false} isStatic={true} />
                            <Stats2 title={"Status"} value={convertStatus(loadedGateway.status)} isLoadingStats={false} isStatic={true} />

                            {loadedGateway.usedBy && <Stats2 title={"Used by"} value={loadedGateway.usedBy || "Unlinked"} isLoadingStats={false} isStatic={true} setNavigateToGroup={setNavigateToGroup}/>}
                            {<Stats2 title={"Owned by"} value={convertGroupIDToName(loadedGateway.ownedByGID)} isLoadingStats={false} isStatic={true} setChangeOwnedBy={setChangeOwnedBy} editable={isAllowed} />}
                            {isAllowed && <Stats2 title={"Billable"} value={loadedGateway.billable == 1 ? "Yes" : "No"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} editable={isAllowed} />}
                            {(loadedGateway.billable == 1 && isAllowed) && <Stats2 title={"Billed to"} value={convertGroupIDToName(loadedGateway.billedToGID) || "Not set"} isLoadingStats={false} isStatic={true} setChangeBilledTo={setChangeBilledTo} isAllowedToChange={isAllowed} editable={isAllowed} />}

                            {/* Inniovate only */}
                            {isAllowed && <Stats2 title={"Billing frequency"} value={loadedGateway.billingFrequency != null ? loadedGateway.billingFrequency : "Not set"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} setChangeBillingFrequency={setChangeBillingFrequency} editable={isAllowed} />}
                            {isAllowed && <Stats2 title={"Date of hardware invoice"} value={loadedGateway.firstInvoiceDate != null ? format(new Date(loadedGateway.firstInvoiceDate), "dd/MM/yyyy") : "Not set"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice} editable={isAllowed} />}
                            {isAllowed && <Stats2 title={"Date of 1st SaaS invoice"} value={loadedGateway.lastInvoiceDate != null ? format(new Date(loadedGateway.lastInvoiceDate), "dd/MM/yyyy") : "Not set"} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={isAllowed} setUnauthorisedClick={setUnauthorisedClick} setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice} setChangeDateOfLastInvoice={setChangeDateOfLastInvoice} editable={isAllowed} />}

                        </div>

                        {isCustomerBillingAllowed && <p style={{marginLeft:"2px", marginTop:"50px", fontWeight:"500", fontSize:"20px", color:"#808080"}}>Customer billing</p>}
                        {isCustomerBillingAllowed &&
                          <div className={classes.container}>
                            <Stats2 title={"Billable:"} value={convertGroupIDToName(loadedGateway.customerBilledToGID) || "No"} status={""} isLoadingStats={false} isStatic={true} setChangeBilledTo={setChangeCustomerBilledTo} isAllowedToChange={true} editable={true} />
                          </div>
                        }
                        </>
                    )}
                </Await>
                    <p>Previous events (Max 100)</p>
                <Await resolve={gatewayEvents}>
                    {(loadedGatewayEvents) => {
                        return (
                            <>
                                <div style={{ display: "flex", width: "100%" }}>
                                    {showLoading ? (
                                        <div style={{ display: "flex", width: "100%" }}>
                                            <DeviceLoadingGrid
                                                CardCount={20} />
                                        </div>
                                    ) : (
                                        <GatewayEvents events={loadedGatewayEvents[0]} />
                                    )}
                                </div>
                            </>
                        )
                    }}
                </Await>
            </div>
        </>
    )
}

export default GatewayEntity;

export async function gatewayLoader({ params }) {
    const gatewayIMEI = params.GatewayIMEI;
    const token = localStorage?.getItem('token');
    const client = localStorage?.getItem('client');

    return { 
        gateway: await getSingleGateway({ token, client }, gatewayIMEI) };
}
